module.exports = __webpack_public_path__ + "static/media/school_logo.cefbec65.png";